<template>
  <footer class="footer tkd-footer">
    <div class="footer-flag"><span></span><span></span></div>
    <div class="footer-inner">
      <div class="footer-brand">
        <img src="/logo.jpg" alt="Taekwondo.com.ua" class="footer-logo">
        <div>
          <b>Секретарська система</b>
          <small>Закрита система Федерації Тхеквондо України</small>
        </div>
      </div>

      <nav class="footer-links">
        <router-link to="/user/profile">Профіль</router-link>
        <router-link to="/user/tournaments">Турніри</router-link>
        <a :href="'mailto:' + contactEmail">Підтримка</a>
      </nav>
    </div>

    <div class="footer-bottom">
      <span>© {{ year }} Taekwondo.com.ua</span>
      <span class="footer-version">
        <span :title="buildTime ? 'Зібрано ' + buildTime : ''">Версія {{ appVersion }}</span>
        <!-- якщо браузер показує стару версію: чистить SW і кеш, вхід зберігається -->
        <button type="button" class="footer-refresh" @click="refreshVersion()" :disabled="refreshing"
                title="Завантажити найновішу версію системи (вхід і чернетки збережуться)">
          <template v-if="refreshing">Оновлення…</template><template v-else><tkd-icon name="refresh"/> Оновити версію</template>
        </button>
      </span>
      <span class="footer-made">Створено з <span class="heart"><tkd-icon name="heart"/></span> у м. Вінниця</span>
    </div>
  </footer>
</template>
<script>
  import 'src/assets/css/tkd-theme.css';
  import { APP_VERSION, BUILD_TIME, hardReload } from 'src/utils/appUpdate';

  export default {
    data () {
      return {
        contactEmail: 'Taekwondo.com.ua@gmail.com',
        year: new Date().getFullYear(),
        buildTime: BUILD_TIME,
        refreshing: false,
      }
    },
    computed: {
      appVersion () {
        return APP_VERSION;
      },
    },
    methods: {
      refreshVersion () {
        this.refreshing = true;
        hardReload();
      },
    },
  }

</script>
<style scoped>
  .tkd-footer {
    margin: 0;
    padding: 0;
    border: 0;
    background: var(--tkd-gradient-hero);
    background-color: var(--tkd-navy);
    font-family: var(--tkd-font);
    color: rgba(255, 255, 255, 0.72);
  }

  .footer-flag {
    display: flex;
    height: 3px;
  }
  .footer-flag span { flex: 1; background: var(--tkd-blue); }
  .footer-flag span + span { background: var(--tkd-yellow); }

  .footer-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    max-width: 1100px;
    margin: 0 auto;
    padding: 28px 15px 22px;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1.3;
  }

  .footer-brand b { display: block; font-size: 15px; font-weight: 800; color: #fff; }
  .footer-brand small { font-size: 13px; color: rgba(255, 255, 255, 0.55); }

  .footer-logo {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 11px;
    object-fit: cover;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);
  }

  .footer-links {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .footer-links a {
    padding: 8px 12px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.72);
    text-decoration: none;
    transition: color 0.15s, background 0.15s;
  }

  .footer-links a:hover,
  .footer-links a.router-link-active { color: #fff; background: rgba(255, 255, 255, 0.08); }
  .footer-links a:focus-visible { outline: 2px solid var(--tkd-yellow); outline-offset: 2px; }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    gap: 8px 16px;
    flex-wrap: wrap;
    max-width: 1100px;
    margin: 0 auto;
    padding: 14px 15px 18px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
  }

  .heart { color: var(--tkd-yellow); }

  .footer-version { display: inline-flex; flex-wrap: wrap; align-items: center; gap: 8px; }

  .footer-refresh {
    margin: 0;
    padding: 2px 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
  }

  .footer-refresh:hover { color: #fff; background: rgba(255, 255, 255, 0.08); }
  .footer-refresh:disabled { cursor: wait; }
  .footer-refresh:focus-visible { outline: 2px solid var(--tkd-yellow); outline-offset: 2px; }

  @media (max-width: 767px) {
    .footer-inner { flex-direction: column; align-items: flex-start; gap: 16px; padding-top: 22px; }
    .footer-links { margin-left: -12px; }
    .footer-bottom { flex-direction: column; }
  }
</style>
